export default __webpack_public_path__ + "static/media/logo-blacked-out.50168ad1.svg";